<template>
  <div class="job-details">
    <router-link :to="{ name: 'DetailJob', params: { code: data.slug } }" class="job-logo">
      <img v-if="data.images_url" :src="data.images_url" alt="" class="job-preview-img">
      <div v-else class="job-logo-placeholder">
        <Icon icon="bx:bxs-briefcase" width="32" height="32" />
      </div>
    </router-link>
    <div class="job-description">
        <h4 v-if="data.category">{{ data.category.title }}</h4>
        <h4 v-else-if="data.category_other">{{ data.category_other }}</h4>
        <h4 v-else class="text-gray-500">—</h4>
        <router-link :to="{ name: 'DetailJob', params: { code: data.slug } }">
            <h3>{{ data.title }}</h3>
        </router-link>
        <p class="job-text">{{ data.excerpt }}</p>
        <div class="job-tags" v-if="tagList && tagList.length">
            <a href="#" v-for="tag in tagList" :key="tag" @click.prevent="$emit('tag-click', tag)">{{ tag }}</a>
        </div>
    </div>
  </div>
</template>
<script>
import { Icon } from '@iconify/vue2'

export default {
  name: 'list_job',
  components: { Icon },
  props: ['data'],
  computed: {
    tagList () {
      if (!this.data || !this.data.tags || typeof this.data.tags !== 'string') return []
      return this.data.tags.split(',').map(t => t.trim()).filter(Boolean)
    }
  }
}
</script>

<style scoped>
.job-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.job-logo-placeholder {
  width: 100%;
  height: 100%;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: #94a3b8;
}
</style>
